import React, { useEffect, useState } from 'react';
import PostEditor from './NewsPanels/PostEditor';
import NewsItem from './NewsPanels/NewsItem';
import { useSelector, useDispatch } from 'react-redux';
import * as newsActions from '../store/modules/newsSlice';
import { bindActionCreators } from 'redux';
import TabMenu from './Common/TabMenu';
import { useLocation } from 'react-router-dom';
import { checkIsNull } from './libs/Util';
import { showToast } from './Common/Messages';

const News = (props) => {
    const location = useLocation();
    const LoginStates = useSelector(state => state.login);
    const NewsStates = useSelector(state => state.news);
    const dispatch = useDispatch();
    const NewsActions = bindActionCreators(newsActions, dispatch);
    const [state, setState] = useState(location.state || {});

    const [menu, setMenu] = useState([]);
    const [current, setCurrent] = useState(null);
    const [postDatas, setPostDatas] = useState([]);
    const [groupname, setGroupName] = useState([]);
    const [groupno, setGroupNo] = useState(state?.groupNo ?? 1);
    const [selectedPost, setSelectedPost] = useState(null);


    const [prevGroupno, setPrevGroupno] = useState(1);
    useEffect(() => {
        getNews();
    }, [LoginStates]);

    useEffect(() => {
        if (menu.length > 0) {
            if (state?.groupNo) {
                setCurrent(menu.find(x => x.groupNo === state.groupNo));
            } else {
                setCurrent(menu[0]);
            }
        }
    }, [menu])
    // ! 체크 필요
    useEffect(() => {
        if (!checkIsNull(groupno)) {
            showPostList();
            setPrevGroupno(groupno);
        }
    }, [groupno]);

    useEffect(() => {
        if (current) {
            if (prevGroupno !== current.groupNo)
                setState({}); // 초기화
            setGroupName(current.title);
            setGroupNo(current.id);
            NewsActions.setGroupNo({ groupno: current.id });
        }
    }, [current])

    useEffect(() => {
        if (selectedPost) {
            clickWrite();
        }
    }, [selectedPost]);

    const getNews = async () => {
        const body = {
            sessionId: LoginStates.sessionId,
            userRole: LoginStates.userRole ?? '',
            newsGroupNo: location.pathname.includes('EditCenter') ? 70 : 1
        }
        const response = await fetch('api/News', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        setMenu(result.data.map(x => { return { id: x.newsId, title: x.title, groupNo: x.newsId, type: 'board', access: x.canAccess, write: x.canWrite, category: x.category } }));
    };

    const executeFetch = (fetchData) => {
        fetch('api/Document/NewsManage', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(fetchData)
        }).then((response) => response.json())
            .then((data) => {
                if (fetchData.workingTag === 'postSave'
                    || fetchData.workingTag === 'postDelete'
                    || fetchData.workingTag === 'commentSave'
                    || fetchData.workingTag === 'commentDelete') {
                    showToast(data.result === 'OK' ? 'success' : 'warning', data.message);
                    showPostList();
                }
                else {
                    setPostDatas(JSON.parse(data.postData));
                    NewsActions.setDisplay({
                        display: 'none'
                    });
                    setSelectedPost(null);
                }
            });
    };
    const clickWrite = (e) => {
        e?.preventDefault();
        if (NewsStates.display === 'none') {
            NewsActions.setDisplay({
                display: 'block'
            });
        }
        else if (NewsStates.display === 'block') {
            NewsActions.setDisplay({
                display: 'none'
            });
            setSelectedPost(null);
        }
    };

        const checkCancelWrite = (e) => {
        if (window.confirm("작성중인 내용을 취소하겠습니까?"))
            clickWrite(e)
    }

    const checkAdmin = () => {
        if (current)
            return current.write == 0 ? false : true;
        else
            return false;
    };

    const handlePanels = (mode) => {
        let current = menu.filter((obj) => { return obj.id === mode })[0];
        setCurrent(current);
    };

    const showPostList = () => {
        const input = {
            userId: '',
            userName: '',
            workingTag: 'postList',
            pageNo: 1,
            groupNo: groupno,
            postInfo: {
                contentType: '',
                postSeq: 0,
                attachSeq: 0,
                commentSeq: 0,
                postData: {
                    title: '',
                    content: '',
                    attachment: [],
                    comment: ''
                }
            }
        };
        executeFetch(input);
    };

    let postNodes = [], index = 0;
    if (!checkIsNull(postDatas)) {
        const postList = postDatas.postDatas;

        if (!checkIsNull(postList)) {
            for (var i = 0; i < postList.length; i++) {
                postNodes.push(
                    <NewsItem key={index++} postSeq={state ? state.postSeq : 0} data={postList[i]} executeFetch={executeFetch} setSelectedPost={setSelectedPost} />
                );
            }
        }
    }

    return (
        <section className="container contents-wrapper-bg">
            <TabMenu clickMenu={handlePanels} mainMenu={menu} current={current ? current.id : 0} title={'새소식'} type='board' />
            <div className="content">
                <div className="doc-wrap">
                    <div className="news">
                        <div className="news-wrap" style={{ width: "100%" }}>
                            <section className="news-top-title">
                                {NewsStates.display === 'block' &&
                                    <button className="" onClick={checkCancelWrite}>
                                        <i className='icoKdc40 arrow-w'></i>
                                </button>
                                }
                                <h2 className='news-page-title'>{groupname}</h2>
                            </section>
                            {NewsStates.display === 'none' ?
                                <>
                                    <section className="news-top-search">
                                        <div className="post-search">
                                            <i className="icoKdc24 magnifier-b"></i>
                                            <input type="text" placeholder={groupname + "에서 검색"} />
                                            {/* <div className="btn-search"><i className="i-search-s"></i></div> */}
                                        </div>
                                        {checkAdmin() &&
                                            <button className="btn-write" onClick={clickWrite}>
                                                글쓰기
                                            </button>
                                        }
                                    </section>
                                    <section className="post-list">
                                        {postNodes}
                                    </section>
                                </>
                                :
                                <>
                                    <PostEditor executeFetch={executeFetch} current={current} setSelectedPost={setSelectedPost} selectedPost={selectedPost} />
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default News;